import gql from 'graphql-tag';

const GET_GEO_LIBRARY = gql`
  query geoLibrary(
    $country: String
    $types: [GeoLibraryResourceType!]
    $regionId: String
    $search: String
    $offset: Int
    $limit: Int
    $forceRefresh: Boolean
  ) {
    geoLibrary(
      country: $country
      types: $types
      regionId: $regionId
      search: $search
      offset: $offset
      limit: $limit
      forceRefresh: $forceRefresh
    ) {
      countryCode
      countryName
      countryId
      generatedAt
      cached
      queryTotal
      counts {
        region
        dma
        city
      }
      entries {
        resourceType
        id
        name
        displayName
        dmaCode
        regionId
        regionName
        regionCode
        countryId
        countryName
        countryCode
      }
    }
  }
`;

export default GET_GEO_LIBRARY;
